import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainDiv: {
    display: 'grid',
    gridTemplateColumns: '6fr 5fr 4fr 3fr',
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      padding: '6px 0 6px 0',
      gridTemplateColumns: '7fr  4fr',
      gap: 3
    }
  }
}))
